import { UserFacingError } from '@/shared/domain'

export type RegistrationFieldIssue = {
  field: string
  message: string
}

export class RegistrationFieldError extends UserFacingError {
  readonly issues: RegistrationFieldIssue[]

  constructor(issues: RegistrationFieldIssue[], message?: string) {
    super(message ?? issues[0]?.message ?? 'Please correct the highlighted fields.')
    this.name = 'RegistrationFieldError'
    this.issues = issues
  }
}
